import { useApiErrorMessage } from "@/shared/api";
import { Skeleton } from "@/shared/ui/skeleton";

import { useAnalysis } from "../../api/useAnalysis";
import type { MatchSummary } from "../../model/Analysis";
import type { AnalysisSection } from "../../model/AnalysisSection";
import { AnalysisFailed } from "../AnalysisFailed";
import { AnalysisProgress } from "../AnalysisProgress";
import { AnalysisReport } from "../AnalysisReport";

type AnalysisBodyProps = {
  match: MatchSummary;
  analysisId: number;
  section: AnalysisSection | undefined;
  onSectionChange: (section: AnalysisSection) => void;
};

// Состояние разбора: подготовка, ошибка или готовый отчёт.
export const AnalysisBody = ({
  match,
  analysisId,
  section,
  onSectionChange,
}: AnalysisBodyProps) => {
  const analysis = useAnalysis(analysisId);
  const error = useApiErrorMessage(analysis.error);
  if (analysis.isPending) {
    return <Skeleton className="h-48" />;
  }
  if (analysis.isError) {
    return (
      <p role="alert" className="text-sm text-bad">
        {error}
      </p>
    );
  }
  const { data } = analysis;
  if (data.status === "done") {
    return (
      <AnalysisReport
        match={match}
        analysis={data}
        section={section}
        onSectionChange={onSectionChange}
      />
    );
  }
  if (data.status === "failed") {
    return <AnalysisFailed matchId={match.match_id} error={data.error} />;
  }
  return <AnalysisProgress analysis={data} />;
};
